// Sidebar.tsx

import React from "react";

type SidebarProps = {
    current: string;
    goTo: (screen: string) => void;
};

const levels = [
    { key: "level1", label: "Level 1: Wie KIKI lernt" },
    { key: "level2", label: "Level 2: Wenig gesehen, wenig gelernt" },
    { key: "level3", label: "Level 3: Je mehr Daten, desto besser!" },
    { key: "level4", label: "Level 4: Sieht sie nichts, lernt sie nichts" },
    { key: "level5", label: "Level 5: Zeichnung statt Foto" },
    { key: "level6", label: "Level 6: Beiß rein!" },
];

export default function Sidebar({ current, goTo }: SidebarProps) {
    return (
        <div
            style={{
                width: 200,
                borderRight: "1px solid #ccc",
                padding: 20,
                backgroundColor: "#f7f7f7",
                height: "100vh",
            }}
        >
            <h3>Navigation</h3>
            <ul style={{ listStyle: "none", padding: 0 }}>
                <li
                    style={{
                        marginBottom: 10,
                        cursor: "pointer",
                        color: current === "welcome" ? "blue" : "black",
                    }}
                    onClick={() => goTo("welcome")}
                >
                    Willkommen
                </li>
                {levels.map((level) => (
                    <li
                        key={level.key}
                        style={{
                            marginBottom: 10,
                            fontWeight: current === level.key ? "bold" : "normal",
                            cursor: "pointer",
                            color: current === level.key ? "blue" : "black",
                        }}
                        onClick={() => goTo(level.key)}
                    >
                        {level.label}
                    </li>
                ))}
            </ul>
        </div>
    );
}

